module.exports = __webpack_public_path__ + "media/AUDIO 04.b7ebb1c0.mp3";